// src/utils/marketRelease.js
// Cadence de mise sur le marché : statut par œuvre (à diffuser, réservée, retenue, diffusée) et année prévue ou réelle.
// Information de planification, jamais une décision de vente. Utile pour un estate, mais aussi pour une collection
// familiale écoulée progressivement.
export const RELEASE_STATUSES = ["to_release", "reserved", "withheld", "released"];

export function cleanReleaseStatus(v) {
  const s = v == null ? "" : String(v).trim();
  return RELEASE_STATUSES.includes(s) ? s : null;
}

export function cleanReleaseYear(v) {
  if (v === null || v === undefined || String(v).trim() === "") return null;
  const n = Number(String(v).trim());
  return Number.isInteger(n) && n >= 1900 && n <= 2200 ? n : null;
}

// rows : { market_release_status, market_release_year }[]
// Retourne le décompte par statut, par année, et la part diffusée de ce qui est planifié.
export function summarizeRelease(rows) {
  const byStatus = { to_release: 0, reserved: 0, withheld: 0, released: 0, unplanned: 0 };
  const years = new Map();
  (rows || []).forEach((r) => {
    const st = cleanReleaseStatus(r?.market_release_status);
    if (!st) { byStatus.unplanned++; return; }
    byStatus[st]++;
    const y = cleanReleaseYear(r?.market_release_year);
    if (y !== null) {
      if (!years.has(y)) years.set(y, { year: y, to_release: 0, reserved: 0, withheld: 0, released: 0 });
      years.get(y)[st]++;
    }
  });
  const planned = RELEASE_STATUSES.reduce((n, k) => n + byStatus[k], 0);
  return {
    total: (rows || []).length,
    planned,
    byStatus,
    byYear: [...years.values()].sort((a, b) => a.year - b.year),
    releasedShare: planned > 0 ? Math.round((byStatus.released / planned) * 100) : 0,
  };
}
